import styled from 'styled-components';

export const StyledCheckboxGroup = styled.div``;

export const Headline = styled.div`
  font-size: 1rem;
  line-height: 1.25;
  font-weight: bold;
  text-align: center;
  margin-bottom: 4px;

  @media ${props => props.theme.tablet} {
    text-align: left;
  }
`;

export const Instructions = styled.div`
  font-size: 0.875rem;
  margin-bottom: 16px;
  text-align: center;

  @media ${props => props.theme.tablet} {
    text-align: left;
    margin-bottom: 24px;
  }
`;

export const Group = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media ${props => props.theme.tablet} {
    flex-wrap: nowrap;
  }
`;
